import { isExternalHttpsRedirect } from '@common/core-layer/utils/external-redirect.utils'

export const isSafeTicketQrImageUrl = (value: string): boolean => isExternalHttpsRedirect(value)
